"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarketService = void 0;

var Repository_1 = __importDefault(require("./Repository"));

var entities_1 = require("../../entities");

var MarketService =
/** @class */
function () {
  function MarketService(baseUrl) {
    this.repository = new Repository_1.default(baseUrl);
  }

  MarketService.prototype.getMarketInfo = function (marketId, domain) {
    return this.repository.getMarketInfo(marketId, domain).then(function (data) {
      return Promise.resolve(new entities_1.MarketEntity(data === null || data === void 0 ? void 0 : data.publicMarket));
    });
  };

  return MarketService;
}();

exports.MarketService = MarketService;